import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoggedUser } from '../models/loggedUser.service';
import { environment } from '../../environments/environment';

export interface MenuItem {
  title: string;
  icon: string;
  url?: string;
  data: string;
  roles: string[];
  sub_items?: MenuItem[];
  requireFunction?: boolean;
  exact?: boolean;
  module?: string;
  disabled?: boolean;
  contentMenu?: boolean;
  fontAwesomeIcon?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private menuItemsSource = new BehaviorSubject<MenuItem[]>([]);
  menuItems$ = this.menuItemsSource.asObservable();

  private activeMenu: 'cms' | 'social' = 'cms';

  private cmsMenuItems: MenuItem[] = [
    {
      icon: 'menu-direito-4',
      title: 'Homepages e páginas',
      data: 'cms/content',
      contentMenu: true,
      requireFunction: true,
      roles: ['PS', 'CI']
    },
    {
      icon: 'menu-direito-5',
      title: 'Mídias',
      data: '/media',
      roles: ['PS', 'CI'],
      url: '/media'
    },
    {
      icon: 'menu-direito-6',
      title: 'Templates',
      data: '/templates',
      url: '/templates',
      roles: ['CI']
    },
    {
      icon: 'grupos-fluxo',
      title: 'Fluxo de Trabalho',
      data: '/workflow',
      url: '/workflow',
      roles: ['FT']
    },
    {
      icon: 'grupos-plus',
      title: 'Módulos',
      data: '/modules',
      url: '/modules',
      roles: ['CI']
    },
    {
      icon: 'calendario-novo',
      title: 'Calendários',
      data: '/calendar',
      url: '/calendar',
      roles: ['CI']
    },
    {
      icon: 'menu-direito-2',
      title: 'Usuários',
      data: '/users',
      url: '/users/content',
      roles: ['UP_PLUS', 'UP'],
    },
    {
      icon: 'interacoes-4',
      title: 'Perfis de Acesso',
      data: '/accessprofiles',
      url: '/accessprofiles',
      roles: ['UP_PLUS', 'UP']
    },
    {
      icon: 'menu-direito-3',
      title: 'Configurações da Plataforma',
      data: '/platform',
      url: '/platform',
      roles: ['PC']
    },
    {
      icon: 'menu-direito-8',
      title: 'Dashboard',
      data: '/dashboard',
      url: '/dashboard',
      roles: ['DR']
    },
  ];

  private socialMenuItems: MenuItem[] = [
    {
      title: 'Página Inicial',
      icon: 'home',
      url: '/social/feed',
      data: '/social/feed',
      roles: [],
      exact: true,
    },
    {
      title: 'Meu Perfil',
      icon: 'usuario-perfil',
      url: '/social/profile',
      data: '/social/profile',
      roles: [],
    },
    {
      title: 'Notificações',
      icon: 'notificacoes',
      url: '/social/notifications',
      data: '/social/notifications',
      roles: [],
    },
    {
      title: 'Descobrir',
      icon: 'drop-perfil-4',
      url: '/social/discover',
      data: '/social/discover',
      roles: [],
    },
    {
      title: 'Recursos Humanos',
      icon: 'movimentacoes-recentes',
      url: '/social/hr',
      data: '/social/hr',
      roles: [],
    },
    {
      title: 'Documentos',
      icon: 'html-galeria',
      url: '/social/documents',
      data: '/social/documents',
      roles: [],
    },
    {
      title: 'Eventos',
      icon: 'wizar-5-2',
      url: '/social/events',
      data: '/social/events',
      roles: [],
    },
    {
      title: 'Organograma',
      icon: 'grupos-fluxo',
      url: '/social/org-chart',
      data: '/social/org-chart',
      roles: [],
    },
    {
      title: 'Colegas',
      icon: 'wizard-2-b',
      url: '/social/colleagues',
      data: '/social/colleagues',
      roles: [],
    },
    {
      title: 'Canais',
      icon: 'menu-direito-2',
      url: '/social/channels/search',
      data: '/social/channels/search',
      roles: [],
    },
    {
      title: 'Salvos',
      icon: 'salvar',
      url: '/social/feed/saved',
      data: '/social/feed/saved',
      roles: [],
    }
  ];

  private socialMenuItemsHidden: MenuItem[] = [
    {
      title: 'Página Inicial',
      icon: 'home',
      url: '/social/feed',
      data: '/social/feed',
      roles: [],
      exact: true,
    },
    // {
    //   title: 'Meu Perfil',
    //   icon: 'usuario-perfil',
    //   url: '/social/profile',
    //   data: '/social/profile',
    //   roles: [],
    // },
    // {
    //   title: 'Notificações',
    //   icon: 'notificacoes',
    //   url: '/social/notifications',
    //   data: '/social/notifications',
    //   roles: [],
    // },
    // {
    //   title: 'Descobrir',
    //   icon: 'drop-perfil-4',
    //   url: '/social/discover',
    //   data: '/social/discover',
    //   roles: [],
    // },
    // {
    //   title: 'Recursos Humanos',
    //   icon: 'movimentacoes-recentes',
    //   url: '/social/hr',
    //   data: '/social/hr',
    //   roles: [],
    // },
    // {
    //   title: 'Documentos',
    //   icon: 'html-galeria',
    //   url: '/social/documents',
    //   data: '/social/documents',
    //   roles: [],
    // },
    // {
    //   title: 'Eventos',
    //   icon: 'wizar-5-2',
    //   url: '/social/events',
    //   data: '/social/events',
    //   roles: [],
    // },
    // {
    //   title: 'Organograma',
    //   icon: 'grupos-fluxo',
    //   url: '/social/org-chart',
    //   data: '/social/org-chart',
    //   roles: [],
    // },
    // {
    //   title: 'Colegas',
    //   icon: 'wizard-2-b',
    //   url: '/social/colleagues',
    //   data: '/social/colleagues',
    //   roles: [],
    // },
    {
      title: 'Canais',
      icon: 'menu-direito-2',
      url: '/social/channels/search',
      data: '/social/channels/search',
      roles: [],
    }
    // ,
    // {
    //   title: 'Salvos',
    //   icon: 'salvar',
    //   url: '/social/feed/saved',
    //   data: '/social/feed/saved',
    //   roles: [],
    // }
  ];


  constructor(private _user: LoggedUser) {

  }

  setMenu(menuType: 'cms' | 'social'): void {
    if (this.activeMenu === menuType && this.menuItemsSource.getValue().length > 0) {
      return;
    }

    this.activeMenu = menuType;
    if (menuType === 'social') {
      if (this._user.getClientId() == '5c32aa1e-0c7d-475b-a861-26c178d4140d' || !environment.production) {
        this.menuItemsSource.next(this.socialMenuItems);
      } else {
        this.menuItemsSource.next(this.socialMenuItemsHidden);
      }
    } else {
      this.menuItemsSource.next(this.cmsMenuItems);
    }
  }

  setCmsMenuItems(items: MenuItem[]) {
    this.cmsMenuItems = items;
    if (this.activeMenu === 'cms') {
      this.menuItemsSource.next(this.cmsMenuItems);
    }
  }

  getCurrentMenu(): 'cms' | 'social' {
    return this.activeMenu;
  }
}
